import axiosInstance, { axiosInstanceCached, axiosInstanceV3 } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

// @ DEPRECATED ==============
//* Create a new bag for a user
// @ payload
// @ id: optional string id for bag, auto-generated if not added
// @ name: optional name for a bag
// @ status: optional active or disabled. Default disabled
export const upsertBag = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_upsert`, payload);
    // response = await axiosInstance.poV3st(`/v3g_upsert`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Create a new bag for a user
// @ payload
// @ id: optional string id for bag, auto-generated if not added
// @ name: optional name for a bag
// @ status: optional active or disabled. Default disabled
export const bagCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_create`, payload);
    // response = await axiosInstanceV3.post(`/bag_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Update bag for a user
// @ payload
// @ id: optional string id for bag, auto-generated if not added
// @ name: optional name for a bag
// @ status: optional active or disabled. Default disabled
export const bagUpdate = async (payload) => {
  let response = {};
  const { id } = payload;
  try {
    response = await axiosInstance.post(`/v3/bag_update`, payload);
    // response = await axiosInstanceV3.post(`/bag_update`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Create a new default bag with standard clubs for a user
// @ can accept status as a field in payload
export const createDefaultBag = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_create_default`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* List the bags for a user
export const userBagList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_list`, payload);
    // response = await axiosInstanceV3.post(`/bag_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Get the active bag for a user
export const userActiveBag = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_get_active`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Get a specific bag for a user
// @ payload
// @ id: ID for bag
export const getUserBag = async (payload) => {
  let response = {};
  const { id = '' } = payload;
  try {
    // response = await axiosInstance.post(`/v3/bag_get`, payload);
    response = await axiosInstanceCached.post(`/v3/bag_get`, payload, {
      id: `user_bag_${id}`,
      cache: {
        ttl: 1000 * 60 * 1, // 1 minute
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Delete a specific bag for a user
// @ payload
// @ id: ID for bag
export const bagDelete = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_delete`, payload);
    // response = await axiosInstanceV3.post(`/bag_delete`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Add club to bag
// @ payload===========
// @ bag_id: ID for bag required
// @ club_id: ID for club required
// @ position: int for position in bag
export const bagAddClub = async (payload) => {
  const { bag_id: bagID } = payload;
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_add_club`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${bagID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Remove club from bag
// @ payload===========
// @ bag_id: ID for bag required
// @ club_id: ID for club required
export const bagRemoveClub = async (payload) => {
  const { bag_id: bagID } = payload;
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_remove_club`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${bagID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Reset to default clubs in bag
// @ payload===========
// @ id: bag_id for bag required
export const bagResetDefault = async (payload) => {
  const { id } = payload;
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/bag_reset_default`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* ============= CLUBS ===================================

//* List club categories
export const clubCategoryList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_category_list`, payload);
    // response = await axiosInstanceV3.post(`/club_category_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* List club types
export const clubTypeList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_type_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* List club makes
export const clubMakeList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_make_list`, payload);
    // response = await axiosInstanceV3.post(`/club_make_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* List club models
export const clubModelList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_model_list`, payload);
    // response = await axiosInstanceV3.post(`/club_model_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* List user clubs
export const userClubList = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_list`, payload);
    // response = await axiosInstanceV3.post(`/club_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ DEPRECATED ==============
//* Create or update a club
// @ id: string
// @ name: string
// @ notes: string
// @ club_type_id: string! required
// @ club_category_id: string! required
// @ club_make_id: string
// @ club_model_id: string
// @ loft: float
// @ shaft_flex: enum [x, s, r, a l]
// @ tag: enum[draw, fade, neutral, half_swing, three_quarter_swing, chip, punch, flop]
export const clubUpsert = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_upsert`, payload);
    // response = await axiosInstanceV3.post(`/club_upsert`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Create a club
// @ id: string
// @ name: string
// @ notes: string
// @ club_type_id: string! required
// @ club_category_id: string! required
// @ club_make_id: string
// @ club_model_id: string
// @ loft: float
// @ shaft_flex: enum [x, s, r, a l]
// @ tag: enum[draw, fade, neutral, half_swing, three_quarter_swing, chip, punch, flop]
export const clubCreate = async (payload = {}) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_create`, payload);
    // response = await axiosInstanceV3.post(`/club_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Update a club
// @ id: string
// @ name: string
// @ notes: string
// @ club_type_id: string! required
// @ club_category_id: string! required
// @ club_make_id: string
// @ club_model_id: string
// @ loft: float
// @ shaft_flex: enum [x, s, r, a l]
// @ tag: enum[draw, fade, neutral, half_swing, three_quarter_swing, chip, punch, flop]
export const clubUpdate = async (payload = {}) => {
  const { bag_id: bagID } = payload;
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_update`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${bagID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Delete a specific club for a user
// @ payload
// @ id: ID for club
export const clubDelete = async (payload) => {
  const { bag_id: bagID } = payload;
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/club_delete`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_bag_${bagID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
